import Seo from "@/components/common/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { shuyuanList } from "@/mocks/manhua";

export default function ShuyuanPage() {
  return (
    <>
      <Seo
        title="好看的韩漫大全免费网站推荐 - 韩漫在线阅读站书源聚合"
        description="韩漫大全免费网站推荐页聚合多个稳定书源，为你解决好看的韩漫大全哪个网站有的问题，标注更新速度、稳定性与下载支持，收藏站点随时在线阅读。"
        keywords="好看的韩漫大全免费网站,韩漫在线阅读站,韩漫书源,好看的韩漫大全推荐站点"
        canonical="https://hmmread.github.io/shuyuan"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "韩漫免费网站书源推荐",
          description: "聚合多个稳定免费的韩漫在线阅读站书源。",
        }}
      />

      <div className="mx-auto w-full max-w-6xl px-4 py-8 md:py-12">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "书源推荐" }]} />

        <div className="mt-4 max-w-2xl">
          <h1 className="heading-font text-2xl font-bold text-foreground-950 md:text-3xl">
            好看的韩漫大全免费网站推荐
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            还在问“好看的韩漫大全哪个网站有”？这里聚合多个稳定免费的韩漫在线阅读站书源，每个站点都标注了更新速度、稳定性评分与下载支持情况，帮你挑到靠谱又流畅的收藏站点。
          </p>
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-2">
          {shuyuanList.map((s) => (
            <article
              key={s.id}
              className="flex flex-col rounded-2xl border border-background-200/70 bg-background-100 p-6 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center gap-4">
                <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                  <i className={`${s.icon} text-2xl`} />
                </span>
                <div className="flex-1">
                  <h2 className="heading-font text-xl font-bold text-foreground-950">{s.name}</h2>
                  <span className="mt-1 inline-block rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-700">
                    {s.tag}
                  </span>
                </div>
                <span className="flex items-center gap-1 text-sm font-bold text-accent-600">
                  <i className="ri-verified-badge-fill" /> 稳定 {s.stability}%
                </span>
              </div>

              <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-600">{s.desc}</p>

              <div className="mt-5 flex flex-wrap gap-2 text-xs">
                <span className="rounded-full bg-secondary-100 px-3 py-1 text-secondary-900">
                  <i className="ri-time-line mr-1" />
                  {s.updateSpeed}
                </span>
                {s.free && (
                  <span className="rounded-full bg-secondary-100 px-3 py-1 text-secondary-900">
                    <i className="ri-refund-2-line mr-1" /> 免费
                  </span>
                )}
                {s.download && (
                  <span className="rounded-full bg-secondary-100 px-3 py-1 text-secondary-900">
                    <i className="ri-download-2-line mr-1" /> 支持下载
                  </span>
                )}
              </div>

              <a
                href={s.url}
                target="_blank"
                rel="nofollow noopener"
                className="mt-5 inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
              >
                <i className="ri-external-link-line" />
                前往 {s.name} 阅读
              </a>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-2xl bg-secondary-100 p-6 md:p-8">
          <h2 className="heading-font text-xl font-bold text-foreground-950">如何选择靠谱的韩漫收藏站点？</h2>
          <ul className="mt-4 grid gap-3 text-sm leading-relaxed text-foreground-700 md:grid-cols-2">
            <li className="flex gap-2"><i className="ri-check-double-line text-secondary-600" /> 优先选择稳定性评分高的站点，减少加载中断。</li>
            <li className="flex gap-2"><i className="ri-check-double-line text-secondary-600" /> 追更新番认准“当日更新”或“首发更新”的书源。</li>
            <li className="flex gap-2"><i className="ri-check-double-line text-secondary-600" /> 需要离线看就选标注“支持下载”的站点。</li>
            <li className="flex gap-2"><i className="ri-check-double-line text-secondary-600" /> 多书源交叉对比，总能找到好看的韩漫大全完整内容。</li>
          </ul>
        </div>
      </div>
    </>
  );
}